import React, { useEffect, useState } from "react";
import logo from '../../assets/images/logo.webp';

const images = [
  "https://images.unsplash.com/photo-1557682250-33bd709cbe85?q=80&w=2029&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1557682260-96773eb01377?q=80&w=2029&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1557682224-5b8590cd9ec5?q=80&w=2029&auto=format&fit=crop",
];
const ArchiApp = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };
  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };
  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, []);
  return (
    <>
      <style>
        {`
          .archiapp {
            min-height: 100vh;
            color: white;
            position: relative;
            overflow: hidden;
          }
          .archiapp-carousel {
            position: fixed;
            inset: 0;
          }
          .archiapp-slide {
            position: absolute;
            inset: 0;
            opacity: 0;
            transition: opacity 1s ease-in-out;
            background-size: cover;
            background-position: center;
          }
          .archiapp-slide.active {
            opacity: 1;
          }
          .archiapp-overlay {
            position: absolute;
            inset: 0;
            background: rgba(102, 51, 153, 0.3);
          }
          .archiapp-nav-arrows {
            position: absolute;
            bottom: 35vh;
            left: 70%;
            transform: translateX(-50%);
            display: flex;
            gap: 20px;
            z-index: 100;
          }

          @media screen and (max-width: 770px){
          .archiapp-nav-arrows {
            position: absolute;
            bottom: 10vh;}

          }
          .archiapp-nav-arrow {
            background: rgba(255, 255, 255, 0.1);
            border: none;
            width: 50px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            color: white;
            font-size: 24px;
            backdrop-filter: blur(5px);
            transition: background-color 0.3s;
          }
          .archiapp-nav-arrow:hover {
            background: rgba(255, 255, 255, 0.2);
          }
          .archiapp-navbar {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            padding: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            z-index: 100;
          }
          .archiapp-logo {
            font-size: 24px;
            font-weight: bold;
          }
            .logoimage {
            height: 30px;
            }
          .archiapp-nav-links {
            display: flex;
            gap: 32px;
          }
          .archiapp-nav-link {
            color: white;
            text-decoration: none;
            opacity: 0.8;
            transition: opacity 0.3s;
          }
          .archiapp-nav-link:hover {
            opacity: 1;
          }
          .archiapp-content {
            min-height: 100vh;
            display: flex;
            align-items: center;
          }
          .archiapp-hero {
            width: 50%;
            padding: 60px;
            backdrop-filter: blur(10px);
            background: rgba(0, 0, 0, 0.2);
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          .archiapp-title {
            font-size: 72px;
            font-weight: bold;
            margin-bottom: 24px;
            line-height: 1.1;
          }
          .archiapp-subtitle {
            font-size: 1rem;
            opacity: 0.9;
            margin-bottom: 32px;
          }
          .archiapp-cta-button {
            background: white;
            color: black;
            border: none;
            padding: 12px 32px;
            border-radius: 100px;
            font-size: 16px;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            gap: 8px;
            transition: opacity 0.3s;
            width: fit-content;
          }
          .archiapp-cta-button:hover {
            opacity: 0.9;
          }
          @media (max-width: 768px) {
            .archiapp-nav-links {
              display: none;
            }
            .archiapp-hero {
              width: 100%;
              padding: 24px;
            }
            .archiapp-title {
              font-size: 48px;
            }
            .archiapp-subtitle {
              font-size: 20px;
            }
          }
            .archiapp-portfolio {
            z-index: 100;
            position: relative;
            background-color: white;
            height: 100vh;
            }
        `}
      </style>
      <>
      <div className="archiapp">
        <div className="archiapp-carousel">
          {images.map((img, index) => (
            <div
              key={index}
              className={`archiapp-slide ${index === currentIndex ? "active" : ""}`}
              style={{
                backgroundImage: `url(${img})`,
              }}
            />
          ))}
          <div className="archiapp-overlay" />
        </div>
        <nav className="archiapp-navbar">
          <div className="archiapp-logo"><img className="logoimage" src={logo}></img></div>
          <div className="archiapp-nav-links">
            <a href="/" className="archiapp-nav-link">
              Home
            </a>
            <a href="#about" className="archiapp-nav-link">
              About Us
            </a>
            <a href="#portfolio" className="archiapp-nav-link">
              Portfolio
            </a>
            <a href="#contact" className="archiapp-nav-link">
              Contact
            </a>
          </div>
        </nav>
        <main className="archiapp-content">
          <div className="archiapp-hero">
            <h1 className="archiapp-title">
                Your mobile app,
              <br />
              brought to life
            </h1>
            <p className="archiapp-subtitle">expertly crafted technology solutions for ambitious businesses</p>
            <button className="archiapp-cta-button">
              Let's talk
              <span>→</span>
            </button>
          </div>
        </main>
        <div className="archiapp-nav-arrows">
          <button className="archiapp-nav-arrow" onClick={prevSlide}>
            ←
          </button>
          <button className="archiapp-nav-arrow" onClick={nextSlide}>
            →
          </button>
        </div>
      </div>
          <div className="archiapp-portfolio">
          Smart code, smarter designs. Architecture meets innovation.
          </div>
    
      </>
      
    </>
  );
}

export default ArchiApp;
